import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  findAllDecisionsPageble,
  deleteErrorDecision,
  findAllDecisionFilterPageable,
} from '../../actions/decision';
import DecisionTable from '../Decision/DecisionTable';
import { TablePagination } from '@material-ui/core';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import { rowsPerPageOptions } from '../../constants/globals.js';
import { changePaginationTextToSerbian } from '../../utils';
import withTranslations from '../../utils/HighOrderComponent';
import { downloadDecisionAttachment } from '../../actions/decisionAttachment';

class DecisionList extends Component {
  componentDidMount() {
    this.props.findAllDecisionsPageble(0, this.props.pageSize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'decision',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllDecisionFilterPageable(0, nextProps.pageSize, postData);
      nextProps.setResetData(false);
    }
  }

  handlePreviewClose = () => {
    this.props.deleteErrorPhysicalEntity();
  };

  handlePageChange = (event, value) => {
    const {
      setActivePage,
      postData,
      pageSize,
      findAllDecisionsPageble,
      findAllDecisionFilterPageable,
    } = this.props || {};
    setActivePage(value);
    postData
      ? findAllDecisionFilterPageable(value, pageSize, postData)
      : findAllDecisionsPageble(value, pageSize);
  };

  handleChangeRowsPerPage = (event, value) => {
    const {
      setPageSize,
      setActivePage,
      postData,
      findAllDecisionsPageble,
      findAllDecisionFilterPageable,
    } = this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllDecisionFilterPageable(0, event.target.value, postData)
      : findAllDecisionsPageble(0, event.target.value);
  };

  render() {
    const {
        t,
        isLoadingNeeded,
        deleteErrorDecision,
        downloadDecisionAttachment,
        decision,
        activePage,
        pageSize,
      } = this.props || {},
      { error, totalElements, decisionList } = decision || {};

    if (isLoadingNeeded) {
      return <LoadingIndicator />;
    }

    return (
      <Fragment>
        <DecisionTable
          decisionList={decisionList}
          deleteError={deleteErrorDecision}
          error={error}
          downloadDecisionAttachment={downloadDecisionAttachment}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  decision: state.decision,
  isLoadingNeeded: state.decision.loading,
  decisionTypeList: state.decisionType.decisionTypeList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllDecisionsPageble: (pageNumber, pageSize) => {
      dispatch(findAllDecisionsPageble(pageNumber, pageSize));
    },

    deleteErrorDecision: () => {
      dispatch(deleteErrorDecision());
    },

    downloadDecisionAttachment: (uuidDocName, decisionName, message) => {
      dispatch(downloadDecisionAttachment(uuidDocName, decisionName, message));
    },
    findAllDecisionFilterPageable: (
      activePage,
      pageSize,
      postData,
      callback
    ) => {
      dispatch(
        findAllDecisionFilterPageable(activePage, pageSize, postData, callback)
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(DecisionList, 'DecisionList'));
